import { ArrowForward } from "@mui/icons-material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { IInvestigationAuditChange } from "../investigation.models";

interface IInvestigationHistoryAuditChangesProps {
  changes: IInvestigationAuditChange[];
}

/** What an audited change moved, one ride history drawer column per line: label, value before, value after. */
export const InvestigationHistoryAuditChanges: FC<
  IInvestigationHistoryAuditChangesProps
> = ({ changes }) => {
  const { t } = useTranslation();

  if (!changes.length) {
    return null;
  }

  return (
    <ul className="history-changes">
      {changes.map(change => (
        <li key={change.key} className="history-change">
          <span className="history-change__label">
            {`${t(change.labelKey)}:`}
          </span>
          {change.before !== undefined && (
            <>
              <span className="history-change__before">{change.before}</span>
              <ArrowForward
                className="history-change__arrow"
                aria-hidden="true"
              />
            </>
          )}
          <span className="history-change__after">{change.after}</span>
        </li>
      ))}
    </ul>
  );
};
